import { defineVariants } from "@/runtime/style-engine/define-variants";

export const inputOtpClasses = defineVariants({
  base: "inline-block",
  variants: {},
});
